<template lang="pug">
  header#header(:class="{ white: whiteHeader}")
    .grid-noBottom
      .col-4
        router-link.home(:to="{ name: 'home'}" @click.native="setHomeState")
          h2
            | California <br/>
            | African American <br/>
            | Museum
          .header-logo
            visual(v-if="!whiteHeader" image="/static/logos/caam_logo_white.svg")
            visual(v-if="whiteHeader" image="/static/logos/caam_logo.svg")
    nav
      h2(@click="showNav" :class="{ active: menu, white: whiteHeader}")
        | {{ menuText }}
      .hamburger(@click="showNav" :class="{ active: menu }" v-if="!menu")
        visual(v-if="!whiteHeader" image="/static/icons/hamburger.svg")
        visual(v-if="whiteHeader" image="/static/icons/hamburger_black.svg")
      .x(@click="showNav" :class="{ active: menu }" v-if="menu")
        visual(v-if="whiteHeader" image="/static/icons/x_out_white.svg")
        visual(v-if="!whiteHeader" image="/static/icons/x_out_black.svg")
      .icon(@click="showSearchOnly" v-if="searchIcon()")
        visual(image="/static/icons/search_white.svg", width="3rem")
      .icon(@click="showSearchOnly" v-if="!searchIcon()")
        visual(image="/static/icons/search_black.svg", width="3rem")
      ul(:class="{ active: menu, white: !whiteHeader, black: whiteHeader}" v-if='!loading')
        li(v-for="item in loadedData.root" v-if="!searchOnly")
          router-link(
            :to="{ name: item.uid}",
            @mouseover.native="showChildren(item.uid, $event)")
            h2
              | {{ item.title }}
          ul(v-if="active === item.uid")
            li(v-for="child in item.children")
              router-link(
                v-if="(item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              router-link(
                v-if="item.uid === 'exhibitions' && formatRoute(child.uid) !== 'current'"
                :to="{name: `${item.uid}-overview`, params: { year: formatRoute(child.uid) }}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              router-link(
                v-if="item.uid === 'exhibitions' && formatRoute(child.uid) === 'current'"
                :to="{name: `${item.uid}`}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              router-link(
                v-if="item.uid === 'programs'"
                :to="{name: `${item.uid}-overview`, params: { category: formatRoute(child.uid) }}"
              )
                h3
                  | {{ formatProgramChildren(child.title.toLowerCase()) }}
              router-link(
                v-if="item.uid === 'learn' && child.uid === '600state'"
                :to="{name: 'blog'}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              router-link(
                v-else-if="item.uid === 'learn' && child.uid !== '600state'"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              router-link(
                v-else-if="(item.uid === 'about' && child.uid !== 'subscribe')"
                :to="{name: `${item.uid}-page`, params: { id: formatRoute(child.uid) }}"
              )
                h3
                  | {{ child.title.toLowerCase() }}
              h3(v-else-if="(item.uid === 'about' && child.uid === 'subscribe')" @click="subscribe")
                | {{ child.title.toLowerCase() }}
        li
          transition(name="fade")
            ul.search(v-if="search" :class="{ black: whiteHeader}")
              li
                input(type="text" v-model="query" @keyup.enter="submit")
              li
                h4(@click="submit")
                  | just ask.
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
export default {
  name: 'top-nav',
  mixins: [DataMixin],

  data () {
    return {
      active: null,
      menu: false,
      menuText: 'menu',
      query: null,
      search: false,
      searchOnly: false,
      whiteHeader: false
    }
  },

  props: ['headerColor'],

  created () {
    this.requestData('root', 'root')
    // this.whiteHeader = this.$ls.get('whiteHeader')
    this.whiteHeader = window._caam_whiteHeader
    // this.$ls.set('menu', false)
    window._caam_menu = false
    this.whiteHeader = this.headerColor === 'white'
  },

  methods: {
    showNav: function () {
      // this.menu = !this.$ls.get('menu')
      this.menu = !window._caam_menu
      this.menuText = this.menu ? 'close' : 'menu'
      this.searchOnly = false
      this.search = false
      // this.$ls.set('menu', this.menu)
      window._caam_menu = this.menu
    },

    showSearchOnly: function () {
      // if (!this.$ls.get('menu')) {
      //   this.showNav()
      // }
      if (!window._caam_menu) {
        this.showNav()
      }

      this.searchOnly = true
      this.search = true
    },

    showChildren: function (uid, event) {
      event.preventDefault()
      window._caam_active = uid
      this.active = window._caam_active
      // this.$ls.set('active', uid)
      // this.active = this.$ls.get('active')
    },

    setHomeState: function () {
      window._caam_introBG = false
      window._caam_intro = false
      // this.$ls.set('introBG', false)
      // this.$ls.set('intro', false)
    },

    submit: function () {
      this.$router.push({name: 'search', query: {query: this.query}})
    },

    subscribe: function () {
      this.$emit('update:subscribe', true)
    },

    searchIcon: function () {
      return (this.whiteHeader && this.menu) || (!this.whiteHeader && !this.menu)
    },

    formatRoute: function (item) {
      return (item.replace(/ |'/g, '-').toLowerCase()).split('!').join('')
    },

    formatProgramChildren: function (item) {
      if (item === 'kids teens and families') {
        return 'kids, teens and families'
      } else if (item === "can't stop won't stop!") {
        return "can't stop, won't stop!"
      } else if (item === 'concerts performances and screenings') {
        return 'concerts, performances and screenings'
      } else {
        return item
      }
    }
  }
}

</script>

<style lang="sass">
  @import '../styles/main'
  #header
    @include no-select
    background-color: #000
    color: white
    position: fixed
    top: 0
    width: 100vW
    z-index: 9999
    @include respond-to(xs)
      height: 5rem
    &.white
      background-color: #FFF
      color: #000
    h2
      line-height: 80%
      padding-top: 2rem
      padding-bottom: 2rem
      display: block
      @include respond-to(xs)
        display: none
    .header-logo
      display: none
      cursor: pointer
      @include respond-to(xs)
        display: flex
        width: 30vW
        height: 5rem
        align-items: center
        .vv-image
          width: 100%
          img
            width: 100%
    nav
      a
        h2, h3
          color: #000
          display: inline
          @include respond-to(md)
            &:hover
              border-bottom: solid 2px #000
          @include respond-to(lg)
            &:hover
              border-bottom: solid 2px #000
      .black
        background-color: #000
        a
          h2, h3
            color: #FFF
            &:hover
              border-bottom: solid 2px #FFF
      >h2
        background-color: rgba(255,55,255,0)
        display: block
        @include respond-to(xs)
          display: none
        &.active
          color: #000
          background-color: rgba(255,55,255,0)
        &.active.white
          color: #FFF
          background-color: rgba(255,255,255,0)
      >h2, >ul, >.icon, >.hamburger, .x
        position: fixed
        padding-left: 0
      >h2, .icon
        z-index: 999999
        cursor: pointer
        top: 6.4rem
        right: 10vW
      >.icon
        padding-top: 2.4rem
        right: 3.81vW
        @include respond-to(xs)
          padding: 0
          top: 0
          left: 85vW
          display: flex
          height: 5rem
          align-items: center
      >.hamburger, .x
        right: 22.5vW
        width: 9vW
        top: 0
        height: 5rem
        display: none
        @include respond-to(xs)
          display: flex
          align-items: center
          .vv-image
            width: 100%
            img
              width: 100%
      >.x
        width: 3rem
        right: 24vW
        z-index: 999999999
      >ul
        left: 66.6vW
        width: 34.4vW
        top: 0
        padding-top: 14rem
        overflow-y: auto
        height: calc(100% - 14rem)
        z-index: 99999
        @include transition(transform, 0.2s, ease-in-out)
        @include translateX(34vW)
        background-color: #FFF
        @include respond-to(xs)
          left: 35.4vW
          width: 65.6vW
          @include translateX(66vW)
          padding-top: 7rem
          height: calc(100% - 7rem)
        &.active
          @include translateX(0)
        >li
          font-size: 1em
          h2, h3
            line-height: 1.2
            padding: 0
            margin-left: $menuMargin
          h4
            padding-left: 0
          h2
            @include respond-to(xs)
              font-size: 3rem
              margin-left: 2rem
          h3
            font-size: 2rem
            line-height: 1.6
            @include respond-to(xs)
              display: none
          .icon
            margin-top: 1.2rem
            .vv-image
              width: 100%
              margin-left: $menuMargin
      .search
        margin-left: $menuMargin
        font-size: 1.6rem
        input
          width: 28.95vW
          @include respond-to(xs)
            width: 61.55vW
            padding: 0
          font-size: 4rem
          font-weight: 700
          outline: 0
          border: none
          border-bottom: solid 2px
          border-radius: 0
          text-align: center
        h4
          font-size: 2rem
          line-height: 200%
          cursor: pointer
          color: #000
        &.black
          input[type='text']
            background-color: #000
            color: #FFF
          h4
            color: #FFF
</style>



// WEBPACK FOOTER //
// TopNav.vue?e3383cb2